module.exports = __webpack_public_path__ + "img/fin_01_废墟苏醒.ff93a6ea.jpg";